"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const Checkbox_1 = __importDefault(require("@material-ui/core/Checkbox"));
const FormControlLabel_1 = __importDefault(require("@material-ui/core/FormControlLabel"));
const colorManipulator_1 = require("@material-ui/core/styles/colorManipulator");
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const changeSidePanel_1 = require("../../actions/app/changeSidePanel");
const createGroupChat_1 = __importDefault(require("../../actions/chats/createGroupChat"));
const Header_1 = __importDefault(require("./Header"));
const CloseButton_1 = __importDefault(require("../shared/CloseButton"));
const CreateGroupChatIcon_1 = __importDefault(require("../shared/CreateGroupChatIcon"));
const NameInput_1 = __importDefault(require("../shared/NameInput"));
const panels_1 = require("../../domain/model/panels");
const PLACEHOLDER_TEXT = "Group Name";
exports.default = react_1.default.memo(NewGroupChatPanel);
const useStyles = makeStyles_1.default((theme) => ({
    nameInput: {
        marginTop: 60
    },
    textBox: {
        marginLeft: 30
    },
    checkBox: {
        margin: "20px auto 0"
    },
    cancelButton: {
        color: colorManipulator_1.alpha(theme.colors.header.primaryTextColor, 0.6)
    }
}));
function NewGroupChatPanel() {
    const dispatch = react_redux_1.useDispatch();
    const classes = useStyles();
    const [chatHistoryVisibleToNewJoiners, setChatHistoryVisibleToNewJoiners] = react_1.useState(false);
    function closePanel() {
        dispatch(changeSidePanel_1.changeLeftPanel(panels_1.LeftPanelType.Chats));
    }
    function handleSubmit(text) {
        closePanel();
        dispatch(createGroupChat_1.default(text, [], chatHistoryVisibleToNewJoiners));
    }
    const newChatIcon = react_1.default.createElement(CreateGroupChatIcon_1.default, { size: "sm" });
    const chatHistoryVisibleCheckBox = react_1.default.createElement(FormControlLabel_1.default, { control: react_1.default.createElement(Checkbox_1.default, { color: "default" }), label: "Chat history visible to new joiners", className: classes.checkBox, checked: chatHistoryVisibleToNewJoiners, onChange: (_, checked) => setChatHistoryVisibleToNewJoiners(checked) });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Header_1.default, { leftIcon: newChatIcon, title: "Create a new group", rightIcon: react_1.default.createElement(CloseButton_1.default, { onClick: closePanel, className: classes.cancelButton }) }),
        react_1.default.createElement(NameInput_1.default, { onSubmit: handleSubmit, placeholderText: PLACEHOLDER_TEXT, minLength: 2, maxLength: 25, children: [chatHistoryVisibleCheckBox], className: classes.nameInput, textBoxClassName: classes.textBox })));
}
